import CIcon from '@coreui/icons-react';
import { CBadge, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react';
import React, { useContext, useEffect, useState } from 'react';
import { components } from 'react-select';
import { MERGE_REPORT_NAME, REPORT_DATA_TYPES, REPORT_NAMES, REPORT_TAB_TYPES, SECTION_REPORT } from '../../../../constants';
import { EventExplorerContext } from './EventExplorer';
import ExportReport from './ExportReport';
import FilterReport from './FilterReport';
import CLabel from '../../../migration/CLabel';
import CTabs from '../../../migration/CTabs';
import ChildMenu from './ChildMenu';
import SavedView from './report-view/dropdown/SavedView';
import SavedReport from './report-view/dropdown/SavedReport';
import { useSelector } from 'react-redux';
import { getDefaultFieldReport } from '../../../../utils/UtilReport';
import PropTypes from 'prop-types';

const MenuList = (props) => {
     return (
          <components.MenuList {...props} className={`${!Array.isArray(props.children) ? 'no-options' : ''}`}>
               {props.children}
          </components.MenuList>
     );
};

const MenuReport = () => {
     const {
          reportName,
          filterMetric,
          setFilterMetric,
          handleGetOption,
          filterDimensions,
          setFilterDimensions,
          filterProperties,
          setFilterProperties,
          filterEvent,
          scoped,
          reportType,
          showChart,
          setShowChart,
          conversionNameMetric,
          externalObjectMetric,
          recordProfile,
          metricsStepForm,
          newProperties,
          newDimensions,
          weight,
          setWeight,
          utmArray,
          eCoItemCategories,
          isDirect,
          dataParamValue,
          listDynamicFields,
          objectID,
     } = useContext(EventExplorerContext);

     const newFilterEvent = filterEvent.filter((item) => item.value && item.type);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const customExternalObjectReport = useSelector((state) => state.subscriber.customExternalObjectReport);
     const checkFilter = filterEvent.some((item) => item.value);
     let { weights, isSectionMenu } = reportType ? REPORT_DATA_TYPES[reportName][scoped] : REPORT_DATA_TYPES[reportName];
     const {dimensionsDefault, propertiesDefault, metricsDefault} = getDefaultFieldReport({ reportType, reportName, scoped, weight, utmArray, properties: newProperties, dimensions: newDimensions, objectID, eCoItemCategories, customExternalObjectReport, handleGetOption });

     const metricDynamic = listDynamicFields?.metrics?.length > 0 ? listDynamicFields?.metrics : [];
     const [activeTab, setActiveTab] = useState(1);

     useEffect(() => {
          if (checkFilter && !recordProfile && dataParamValue) {
               setActiveTab('Filter');
          }
     }, [checkFilter, recordProfile]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleTabClick = (tabIndex) => {
          if (tabIndex !== activeTab) {
               setActiveTab(tabIndex);
          } else {
               setActiveTab('');
          }
     };

     const handleChangeWeight = (e) => {
          setWeight({ ...e, noneDirect: isDirect });
     };

     const conversionNameAddSection = (conversions) => {
          if ([REPORT_NAMES.BY_PROPERTY, REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION, REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY, ...MERGE_REPORT_NAME].includes(reportName)) {
               const newConversions = conversions.map((el) => {
                    const element = el;
                    element.section = MERGE_REPORT_NAME.includes(reportName) ? SECTION_REPORT.COUNT : SECTION_REPORT.COUNTS;

                    if(MERGE_REPORT_NAME.includes(reportName) && el.label.includes('Ecommerce')) {
                         element.section = 'Ecommerces';
                         return element;
                    } else {
                         element.sectionParent = SECTION_REPORT.INDIVIDUAL_CONV;
                    }

                    if (el.key.includes('Value')) {
                         element.section = SECTION_REPORT.VALUES;
                    }
                    if (el.key.includes('Rate')) {
                         element.section = SECTION_REPORT.CONV_RATE;
                    }
                    return element;
               })
               return newConversions;
          }

          if([REPORT_NAMES.BY_CONVERSION].includes(reportName)){
               return [];
          }
          return conversions;
     };

     return (
          <>
               <CTabs activeTab={activeTab} onActiveTabChange={handleTabClick} className="mb-2">
                    <div className="menu-report justify-content-end">
                         {!recordProfile && activeAccount.savedReport && (
                              <SavedReport />
                         )}
                         {!recordProfile && (
                              <SavedView
                                   propertiesOptions={handleGetOption({ option: propertiesDefault })}
                                   dimensionsOptions={handleGetOption({ option: dimensionsDefault })}
                                   metricOptions={handleGetOption({
                                        option: [...metricsDefault, ...conversionNameAddSection(conversionNameMetric), ...metricsStepForm, ...externalObjectMetric, ...metricDynamic],
                                        type: 'option',
                                        filter: [],
                                        reportName,
                                        isSectionMenu,
                                   })}
                              />
                         )}
                         <CNav variant="tabs" className="menu-report-list">
                              {reportName === REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT && (
                                   <CNavItem>
                                        <CNavLink
                                             className={activeTab === REPORT_TAB_TYPES.MODEL ? 'active' : ''}
                                             onClick={() => handleTabClick(REPORT_TAB_TYPES.MODEL)}
                                             data-tab={REPORT_TAB_TYPES.MODEL}
                                        >
                                             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 448 512">
                                                  <path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                                             </svg>
                                             <CLabel>{REPORT_TAB_TYPES.MODEL}</CLabel>
                                        </CNavLink>
                                   </CNavItem>
                              )}
                              {dimensionsDefault.length > 0 && (
                                   <CNavItem>
                                        <CNavLink
                                             className={activeTab === REPORT_TAB_TYPES.DIMENSIONS ? 'active' : ''}
                                             onClick={() => handleTabClick(REPORT_TAB_TYPES.DIMENSIONS)}
                                             data-tab={REPORT_TAB_TYPES.DIMENSIONS}
                                        >
                                             <CIcon icon="icon-dimension" />
                                             <CLabel>{REPORT_TAB_TYPES.DIMENSIONS}</CLabel>
                                        </CNavLink>
                                   </CNavItem>
                              )}
                              {propertiesDefault.length > 0 && ![REPORT_NAMES.BY_CONVERSION, REPORT_NAMES.BY_PROPERTY].includes(reportName) &&  (
                                   <CNavItem>
                                        <CNavLink
                                             className={activeTab === REPORT_TAB_TYPES.PROPERTIES ? 'active' : ''}
                                             onClick={() => handleTabClick(REPORT_TAB_TYPES.PROPERTIES)}
                                             data-tab={REPORT_TAB_TYPES.PROPERTIES}
                                        >
                                             <CIcon icon="icon-properties" />
                                             <CLabel>{REPORT_TAB_TYPES.PROPERTIES}</CLabel>
                                        </CNavLink>
                                   </CNavItem>
                              )}
                              <CNavItem>
                                   <CNavLink
                                        className={activeTab === REPORT_TAB_TYPES.METRICS ? 'active' : ''}
                                        onClick={() => handleTabClick(REPORT_TAB_TYPES.METRICS)}
                                        data-tab={REPORT_TAB_TYPES.METRICS}
                                   >
                                        <CIcon icon="icon-metrics" />
                                        <CLabel>{REPORT_TAB_TYPES.METRICS}</CLabel>
                                   </CNavLink>
                              </CNavItem>
                              <CNavItem>
                                   <CNavLink
                                        className={`notification-bell filter-report-bell mr-0 ${activeTab === REPORT_TAB_TYPES.FILTER ? 'active' : ''}`}
                                        onClick={() => handleTabClick(REPORT_TAB_TYPES.FILTER)}
                                        data-tab={REPORT_TAB_TYPES.FILTER}
                                   >
                                        <CIcon icon="icon-filter-report" />
                                        <CLabel>{REPORT_TAB_TYPES.FILTER}</CLabel>
                                        {newFilterEvent?.length > 0 && (
                                             <CBadge  shape="pill" color="danger" className={newFilterEvent.length > 99 ? 'big-number' : ''}>{newFilterEvent.length}</CBadge>
                                        )}
                                   </CNavLink>
                              </CNavItem>
                              <CNavItem>
                                   <CNavLink
                                        className={activeTab === REPORT_TAB_TYPES.EXPORT ? 'active' : ''}
                                        onClick={() => handleTabClick(REPORT_TAB_TYPES.EXPORT)}
                                        data-tab={REPORT_TAB_TYPES.EXPORT}
                                   >
                                        <CIcon icon="icon-export" />
                                        <CLabel>{REPORT_TAB_TYPES.EXPORT}</CLabel>
                                   </CNavLink>
                              </CNavItem>
                         </CNav>
                         {!recordProfile && (
                              <div className="chartButton">
                                   <button
                                        className={`buttonChartIcon${showChart ? ' active' : ''}`}
                                        type="button"
                                        onClick={() => setShowChart((prev) => !prev)}
                                   >
                                        <CIcon icon="iconChart" style={{ color: `${showChart ? '#ffff' : '#20a8d8'}` }} />
                                   </button>
                              </div>
                         )}
                    </div>
                    <CTabContent>
                         {reportName === REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT && (
                              <CTabPane visible={activeTab === REPORT_TAB_TYPES.MODEL} data-tab={REPORT_TAB_TYPES.MODEL}>
                                   <ChildMenu
                                        defaultValue={weight}
                                        MenuList={MenuList}
                                        handleChangeField={handleChangeWeight}
                                        type={REPORT_TAB_TYPES.MODEL}
                                        options={weights.filter((el) => el.value !== weight.value)}
                                        isMulti={false}
                                   />
                              </CTabPane>
                         )}
                         <CTabPane visible={activeTab === REPORT_TAB_TYPES.DIMENSIONS} data-tab={REPORT_TAB_TYPES.DIMENSIONS}>
                              <ChildMenu
                                   defaultValue={filterDimensions}
                                   MenuList={MenuList}
                                   handleChangeField={setFilterDimensions}
                                   type={REPORT_TAB_TYPES.DIMENSIONS}
                                   options={handleGetOption({
                                        option: dimensionsDefault,
                                        type: 'option',
                                        filter: [],
                                        menuFilter: 'filterDimension',
                                        reportName,
                                   })}
                                   allOption={handleGetOption({ option: dimensionsDefault })}
                                   isMulti={
                                        [REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT, REPORT_NAMES.ECOMMERCE_ITEMS].includes(reportName)
                                             ? false
                                             : true
                                   }
                              />
                         </CTabPane>
                         <CTabPane visible={activeTab === REPORT_TAB_TYPES.PROPERTIES} data-tab={REPORT_TAB_TYPES.PROPERTIES}>
                              <ChildMenu
                                   defaultValue={filterProperties}
                                   MenuList={MenuList}
                                   handleChangeField={setFilterProperties}
                                   type={REPORT_TAB_TYPES.PROPERTIES}
                                   options={handleGetOption({
                                        option: [...propertiesDefault],
                                        type: 'option',
                                        filter: [],
                                        menuFilter: 'filterProperty',
                                        reportName,
                                        isSectionMenu,
                                   })}
                                   allOption={handleGetOption({ option: [...propertiesDefault] })}
                                   isMulti={true}
                              />
                         </CTabPane>
                         <CTabPane visible={activeTab === REPORT_TAB_TYPES.METRICS} data-tab={REPORT_TAB_TYPES.METRICS}>
                              <ChildMenu
                                   defaultValue={filterMetric}
                                   MenuList={MenuList}
                                   handleChangeField={setFilterMetric}
                                   type={REPORT_TAB_TYPES.METRICS}
                                   options={handleGetOption({
                                        option: [...metricsDefault, ...conversionNameAddSection(conversionNameMetric), ...metricsStepForm, ...externalObjectMetric, ...metricDynamic],
                                        type: 'option',
                                        filter: [],
                                        reportName,
                                        isSectionMenu,
                                   })}
                                   allOption={handleGetOption({ option: [...metricsDefault, ...conversionNameAddSection(conversionNameMetric), ...metricsStepForm,...externalObjectMetric, ...metricDynamic] })}
                                   isMulti={true}
                                   isUnrelated={[REPORT_NAMES.BY_CONVERSION, REPORT_NAMES.BY_PROPERTY, ...MERGE_REPORT_NAME].includes(reportName)}
                              />
                         </CTabPane>
                         <CTabPane visible={activeTab === REPORT_TAB_TYPES.FILTER} data-tab={REPORT_TAB_TYPES.FILTER}>
                              {
                                   // recordProfile ? <RecordFilter /> :
                                   <FilterReport />
                              }
                         </CTabPane>
                         <CTabPane visible={activeTab === REPORT_TAB_TYPES.EXPORT} data-tab={REPORT_TAB_TYPES.EXPORT}>
                              <ExportReport />
                         </CTabPane>
                    </CTabContent>
               </CTabs>
          </>
     );
};

MenuList.propTypes = {
     children: PropTypes.node,
};

export default MenuReport;
